import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Aluguer de Barco em Vilamoura · Iate Privado Tripulado · Morningstar";
const DESC = "Aluguer de barco em Vilamoura no Morningstar — um iate privado totalmente tripulado para até 18 pessoas. Meio-dia, pôr-do-sol, Benagil e dia completo a partir da Marina de Vilamoura.";
const PATH = "/pt/aluguer-de-barco-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.boatHireVilamoura;

export const Route = createFileRoute("/pt/aluguer-de-barco-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Aluguer de Barco · Vilamoura · Algarve",
        title: "Aluguer de barco em Vilamoura a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Um iate privado totalmente tripulado para até 18 pessoas, com partida da Marina de Vilamoura. Skipper, deckhand, combustível, bebidas e tapas — tudo incluído. Sem necessidade de carta.",
        ctaPrimary: "Ver opções",
        ctaSecondary: "Pedir orçamento",
      }}
      pageContent={CONTENT.pt}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "aluguer de barco vilamoura, aluguer barco algarve, aluguer iate vilamoura, alugar barco vilamoura",
      altPath: { en: "/boat-hire-vilamoura", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Boat Hire from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Aluguer de Barco Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.pt.faqs)) },
      ],
    }),
});
